    document.addEventListener('DOMContentLoaded', () => {
      const disableImageLinks = () => {
        document.querySelectorAll('[data-essential-upsell-element="image-container"]').forEach(el => {
          el.onclick = e => e.preventDefault();
        });
      };
      new MutationObserver(disableImageLinks).observe(document.body, { childList: true, subtree: true });
      disableImageLinks();
    });